(function() { module.exports = window["Next"]["Range"]; }());